"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RETAILER_FRAGMENT", {
    enumerable: true,
    get: ()=>RETAILER_FRAGMENT
});
const _graphqlRequest = require("graphql-request");
const RETAILER_FRAGMENT = (0, _graphqlRequest.gql)`
    fragment addressFragment on AddressObject {
        line1
        line2
        city
        postalCode
        state
        country
    }

    fragment bannerColorsFragment on BannerColorConfiguration {
        background
        border
        color
        id
    }

    fragment deliverySettingsFragment on DeliverySettings {
        afterHoursOrderingForDelivery
        afterHoursOrderingForPickup
        deliveryArea
        deliveryFee
        deliveryMinimum
        disablePurchaseLimits
        limitPerCustomer
        pickupMinimum
        scheduledOrderingForDelivery
        scheduledOrderingForPickup
    }

    fragment hoursDayFragment on HoursDay {
        active
        start
        end
    }

    fragment hoursFragment on Hours {
        Sunday {
            ...hoursDayFragment
        }
        Monday {
            ...hoursDayFragment
        }
        Tuesday {
            ...hoursDayFragment
        }
        Wednesday {
            ...hoursDayFragment
        }
        Thursday {
            ...hoursDayFragment
        }
        Friday {
            ...hoursDayFragment
        }
        Saturday {
            ...hoursDayFragment
        }
    }

    fragment retailerFragment on Retailer {
        phone
        address
        addressObject {
            ...addressFragment
        }
        banner {
            colors {
                ...bannerColorsFragment
            }
            html
        }
        coordinates {
            latitude
            longitude
        }
        deliverySettings {
            ...deliverySettingsFragment
        }
        description
        fulfillmentOptions {
            curbsidePickup
            delivery
            driveThruPickup
            pickup
        }
        hours {
            delivery {
                ...hoursFragment
            }
            pickup {
                ...hoursFragment
            }
            driveThruPickup {
                ...hoursFragment
            }
            curbsidePickup {
                ...hoursFragment
            }
            regular {
                ...hoursFragment
            }
            specialHours {
                startDate
                endDate
                specialOperatingHours {
                    date
                    curbsidePickup {
                        ...hoursDayFragment
                    }
                    delivery {
                        ...hoursDayFragment
                    }
                    driveThruPickup {
                        ...hoursDayFragment
                    }
                    pickup {
                        ...hoursDayFragment
                    }
                }
                name
            }
        }
        id
        menuTypes
        name
        paymentMethodsByOrderTypes {
            orderType
            paymentMethods
        }
        settings {
            menuWeights
        }
    }
`;
